<template>
  <div>
    <div class="circle" @click="scrollToTop">
      <i class="el-icon-upload2"></i>
      <!-- <div>TOP</div> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    scrollToTop () {
      this.$emit('toTop')
    }
  }
}
</script>
<style lang="less" scoped>
.circle{
  width: 40px;
  height: 40px;
  border-radius: 40px;
  background: rgba(255, 255, 255, .6);
  color: #b81b26;
  position: fixed;
  z-index: 10000;
  right: 38px;
  bottom: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
  font-family: hzgb;
  // padding-bottom: 10px;
  cursor: pointer;
  i{
    font-size: 22px;
  }
  &:hover{
    background-color: #fff;
  }
}
</style>
